import { render, staticRenderFns } from "./PatientDeleteModal.vue?vue&type=template&id=e058d3f0&scoped=true"
import script from "./PatientDeleteModal.vue?vue&type=script&lang=js"
export * from "./PatientDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./PatientDeleteModal.vue?vue&type=style&index=0&id=e058d3f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e058d3f0",
  null
  
)

export default component.exports